module.exports = __webpack_public_path__ + "assets/img/n3.cc4a284e.png";